<div [attr.dir]="direction">
  <wsd-header></wsd-header>
  <router-outlet></router-outlet>
  <wsd-footer></wsd-footer>
</div>
